import styled from 'styled-components';
import { HTMLAttributes, DetailedHTMLProps } from 'react';
import { Question } from '@sleepunique/types/question-type';

export const Container = styled.div<Question>`
  margin-bottom: var(--spacing-5);
  width: 100%;

  ${({ theme }) => theme.breakpoints.minBp('tablet')} {
    margin-bottom: var(--spacing-6);
  }

  .question-text {
    &__title {
      font-size: 1.875rem;
      line-height: 1.06;
      color: var(--color-sleepunique-light-red);

      ${({ theme }) => theme.breakpoints.minBp('tablet')} {
        font-size: 2.5rem;
        line-height: 2.625rem;
      }
    }
  }
`;
